import { Input } from "../../ui/input";
import { Field, Pick, Section } from "./FormBits";
import { PAY_METHODS, money } from "./settlementApi";

const ACTIONS = [
  { value: "", label: "Leave as is" },
  { value: "adopt", label: "Use in this settlement" },
  { value: "convert_to_rent", label: "Convert to rent difference" },
];
const MODES = [
  { value: "bond_deduction", label: "Take from bond" },
  { value: "external_paid", label: "Paid externally (cash / bank)" },
  { value: "external_pending", label: "Still owed by customer" },
];

const statusText = (c) => [c.status.replace(/_/g, " "), c.from_bond && "from bond", c.historical && "historical"].filter(Boolean).join(" · ");

function ExistingRow({ c, op, onChange }) {
  const tid = `settle-existing-${c.id}`;
  return (
    <div className="border border-dashed border-[#282828]/10 p-3 space-y-2" data-testid={tid}>
      <div className="flex justify-between gap-2 text-[12px]">
        <span className="text-[#282828] font-medium">{c.label} {money(c.amount)}{c.description && <span className="text-[#676664] font-normal"> — {c.description}</span>}</span>
        <span className="text-[10px] uppercase tracking-wider text-[#676664]" data-testid={`${tid}-status`}>{statusText(c)}</span>
      </div>
      {c.adopt_blocked ? (
        <div className="text-[11px] text-[#676664]" data-testid={`${tid}-blocked`}>Can't be changed here: {c.adopt_blocked}</div>
      ) : (
        <div className="grid grid-cols-3 gap-2">
          <Field label="Action"><Pick value={op?.action || ""} onChange={(v) => onChange({ action: v })} options={c.type === "rental_adjustment" ? ACTIONS.filter((a) => a.value !== "convert_to_rent") : ACTIONS} testid={`${tid}-action`} /></Field>
          {op?.action && <Field label="Settle by"><Pick value={op.mode} onChange={(v) => onChange({ mode: v })} options={MODES} testid={`${tid}-mode`} /></Field>}
          {op?.action && op.mode === "external_paid" && <Field label="Paid by"><Pick value={op.method} onChange={(v) => onChange({ method: v })} options={PAY_METHODS} testid={`${tid}-method`} /></Field>}
        </div>
      )}
    </div>
  );
}

function BondRefundFix({ f, set, summary }) {
  return (
    <div className="grid grid-cols-2 gap-2 items-end" data-testid="settle-bond-fix">
      <div className="text-[12px] text-[#676664]">Recorded bond refund: <span className="text-[#282828] font-medium" data-testid="settle-bond-fix-current">{money(summary.bond_refund_recorded)}</span></div>
      {summary.bond_refund_fix_blocked ? (
        <div className="text-[11px] text-[#676664]" data-testid="settle-bond-fix-blocked">Can't be corrected: {summary.bond_refund_fix_blocked}</div>
      ) : (
        <Field label="Correct to $ (blank = keep)"><Input type="number" min="0" step="0.01" value={f.bondFix} onChange={(e) => set({ bondFix: e.target.value })} className="h-9" data-testid="settle-bond-fix-input" /></Field>
      )}
    </div>
  );
}

export function ExistingRecordsSection({ f, set, summary }) {
  const rows = summary.existing_charges || [];
  if (!rows.length && !(summary.original_bond > 0)) return null;
  const upd = (id, patch) => {
    const next = { ...f.existing, [id]: { mode: "bond_deduction", method: "", ...f.existing[id], ...patch } };
    if (!next[id].action) delete next[id];
    set({ existing: next });
  };
  return (
    <Section title="Existing records — use or correct instead of adding duplicates" testid="settle-existing-section">
      {rows.map((c) => <ExistingRow key={c.id} c={c} op={f.existing[c.id]} onChange={(p) => upd(c.id, p)} />)}
      {summary.original_bond > 0 && <BondRefundFix f={f} set={set} summary={summary} />}
      <div className="text-[11px] text-[#676664]">Original values stay in the audit trail. Nothing is saved until you confirm the preview.</div>
    </Section>
  );
}
